import axios from "axios";

export default {
    logIn(usuario) {
        let params =
            "grant_type=password&username=" +
            usuario.aliasUsuario +
            "&password=" +
            usuario.password;
        let body = params.toString();

        return axios
            .post("/login", body)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log("Error");
                console.log(e);
                throw e;
            });
    },
    publicLogin(pin) {

        return axios
            .post(`/api/pin-authenticate/${pin}`)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log("Error");
                console.log(e);
                throw e;
            });
    },
    logOut() {
        const tokenAuth = localStorage.getItem("access_token");
        const headerAuth = { headers: { Authorization: `${tokenAuth}` } };
        let body = "";
        return axios
            .post("api/logout", body, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },
};